module.exports = __webpack_public_path__ + "img/NORDIC_FISH.6e436699.png";